// ============================================================================
// CATEGORY API
// ============================================================================
// ./client/src/api/categoryAPI.js

import axiosInstance from '../utilities/axiosInstance';

const categoryAPI = {
  // Get all categories
  getAllCategories: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/api/category', { params });
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: `Failed to get categories: ${error.message}` };
    }
  },

  // Get category by ID
  getCategoryById: async (categoryId) => {
    try {
      const response = await axiosInstance.get(`/api/category/${categoryId}`);
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: `Failed to get category: ${error.message}` };
    }
  },

  // Get category by title
  getCategoryByTitle: async (title) => {
    try {
      const response = await axiosInstance.get(`/api/category/title/${title}`);
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: `Failed to get category: ${error.message}` };
    }
  },

  // Create new category
  createCategory: async (data) => {
    try {
      const response = await axiosInstance.post('/api/category', data);
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: `Failed to create category: ${error.message}` };
    }
  },

  // Update category
  updateCategory: async (categoryId, data) => {
    try {
      const response = await axiosInstance.put(`/api/category/${categoryId}`, data);
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: `Failed to update category: ${error.message}` };
    }
  },

  // Delete category
  deleteCategory: async (categoryId, adminData) => {
    try {
      const response = await axiosInstance.delete(`/api/category/${categoryId}`, { data: adminData });
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: `Failed to delete category: ${error.message}` };
    }
  },

  // Add tag to category
  addTag: async (categoryId, data) => {
    try {
      const response = await axiosInstance.post(`/api/category/${categoryId}/tags`, data);
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: `Failed to add tag: ${error.message}` };
    }
  },

  // Remove tag from category
  removeTag: async (categoryId, data) => {
    try {
      const response = await axiosInstance.delete(`/api/category/${categoryId}/tags`, { data });
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: `Failed to remove tag: ${error.message}` };
    }
  },

  // Get categories by tag
  getCategoriesByTag: async (tag) => {
    try {
      const response = await axiosInstance.get(`/api/category/tag/${tag}`);
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: `Failed to get categories by tag: ${error.message}` };
    }
  },

  // Search categories
  searchCategories: async (query) => {
    try {
      const response = await axiosInstance.get('/api/category/search', { params: { q: query } });
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: `Failed to search categories: ${error.message}` };
    }
  },

  // Update course count
  updateCourseCount: async (categoryId) => {
    try {
      const response = await axiosInstance.patch(`/api/category/${categoryId}/course-count`);
      return response.data;
    } catch (error) {
      return error?.response?.data || { success: false, error: `Failed to update course count: ${error.message}` };
    }
  }
};

export default categoryAPI;